<template>
  <j-form-container :disabled="disabled">
    <a-form :form="form" slot="detail">
      <a-row>
        <a-col :span="6">
          <a-form-item v-has="'buffer3'" label="结算" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['buffer3']" :placeholder="$t('label.pleaseEnterTheContractCode')"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </j-form-container>
</template>
<script>
import pick from 'lodash.pick'
import { getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import JFormContainer from '@/components/jeecg/JFormContainer'

export default {
  name: 'FeeItemInfoForm',
  components: {
    JFormContainer,
  },
  props:{
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      validatorRules: {

      },
      confirmLoading: false,
    }
  },
  methods:{
    initFormData(url,id){
      this.clearFormData()
      if(!id){
        this.edit({})
      }else{
        getAction(url,{id:id}).then(res=>{
          if(res.success){
            let records = res.result
            if(records && records.length>0){
              this.edit(records[0])
            }
          }
        })
      }
    },
    edit(record){
      this.model = Object.assign({}, record)
      console.log("FeeItemInfoForm-edit",this.model);
      let fieldval = pick(this.model,'buffer3')
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldval)
      })
    },
    getFormData(){
      let formdata_arr = []
      this.form.validateFields((err, values) => {
        if (!err) {
          let formdata = Object.assign(this.model, values)
          let isNullObj = true
          Object.keys(formdata).forEach(key=>{
            if(formdata[key]){
              isNullObj = false
            }
          })
          if(!isNullObj){
            formdata_arr.push(formdata)
          }
        }else{
          this.$emit("validateError","结算单详情表单校验未通过");
        }
      })
      console.log("结算单详情表单数据集",formdata_arr);
      return formdata_arr;
    },
    popupCallback(row){
      this.form.setFieldsValue(pick(row,'buffer3'))
    },
    clearFormData(){
      this.form.resetFields()
      this.model={}
    },
  }
}
</script>
